import { PublicPageSeoPageKind } from './public-page-seo.models';
import { buildTenantPublicPath, resolveTenantPublicBaseUrl } from './public-seo-url.utils';

export function buildPublicCanonicalUrl(
  origin: string,
  slug: string,
  pageKind: PublicPageSeoPageKind,
  publicBaseUrl?: string | null
): string {
  const base = resolveTenantPublicBaseUrl(origin, publicBaseUrl);
  const segment =
    pageKind === 'catalog'
      ? ('tienda' as const)
      : pageKind === 'services'
        ? ('servicios' as const)
        : ('' as const);
  return `${base}${buildTenantPublicPath(slug, segment, publicBaseUrl)}`;
}
